import mixitup from 'mixitup';

import $ from 'jquery';

if ( $( '.js-filtered-grid' ).length > 0 ) {
	var mixer = mixitup( '.js-filtered-grid', {
		selectors: {
			target: '.js-filtered-grid-item',
			control: '.js-filtered-grid-filter'
		},
		classNames: {
			block: 'js-filtered-grid',
			elementFilter: 'filter'
		},
		animation: {
			effects: 'fade scale translateZ(0)',
			duration: 300
		}
	} );
}

// Prevents default link behavior
$( '.js-filtered-grid-filter' ).on( 'click', function( event ) {
	event.preventDefault();
} );


